import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './ActionBarStrip.scss';
var ActionBarStrip = forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children;
    var t = useTranslation().t;
    return (React.createElement(Section, { className: classnames(s['root'], className), ref: ref, "data-hook": BiDataHook.DEVIATION_ACTION_BAR },
        React.createElement(VisuallyHidden, null,
            React.createElement(Heading, null, t('actionbar.a11y.heading'))),
        children));
});
ActionBarStrip.displayName = 'ActionBarStrip';
export default ActionBarStrip;
//# sourceMappingURL=ActionBarStrip.js.map